import { QUERY_KEYS } from 'lib/util/routing'
import { useHistory } from 'react-router-dom'

export default function useSearchQuery() {
  const history = useHistory()

  return new URLSearchParams(history.location.search).get(QUERY_KEYS.search)
}
